import { DAY_NAME_FORMAT } from 'consts/dateFormats';
import dayjs from 'dayjs';

export const parseStringIntoDayName = (dateString: string) => {
    const date = dayjs(dateString);

    return date.format(DAY_NAME_FORMAT);
};
